import { Button } from "antd";
import { ButtonSize } from "antd/es/button";
import { ButtonType } from "antd/es/button/buttonHelpers";
import Title from "antd/es/typography/Title";
import classNames from "classnames";
import { ReactElement } from "react";

interface ButtonProps {
    text: string;
    icon: ReactElement;
    callback: () => void;
    className?: string;
    type?: ButtonType;
    size?: ButtonSize;
}

interface ActionTitleProps {
    title: {
        text: string;
        level?: 1 | 2 | 3 | 4;
    };
    buttons?: Array<ButtonProps>;
    className?: string;
}

export const ActionTitle = ({ title, className, buttons }: ActionTitleProps) => {
    return (
        <div className={classNames("mb-4 flex flex-row justify-between", className)}>
            <Title level={title.level ?? 3} className={"!mb-0"}>{title.text}</Title>

            {buttons && Array.isArray(buttons) && (
                <div className="flex flex-row gap-x-3">
                    {buttons.map((button, i) => (
                        <Button
                            key={i}
                            type={button.type ?? "primary"}
                            icon={button.icon}
                            size={button.size ?? "middle"}
                            onClick={button.callback}
                            className={button.className}
                        >
                            {button.text}
                        </Button>
                    ))}
                </div>
            )}
        </div>
    );
};
